import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';
// configure Swiper to use modules

Swiper.use([Navigation, Pagination, Scrollbar]);

$(document).ready(function() {
  $('.service_slider').each(function() {

    var $slider = $(this);
    var $slides = $slider.find('.service_slider__slides');
    var $prev = $slider.find('.service_slider__prev');
    var $next = $slider.find('.service_slider__next');

    var slides_perview_desktop = 3;
    console.log("slides_perview_desktop: " + slides_perview_desktop);

    if ($(this).data('slides_perview_desktop')) {
      var slide_perview_data = $(this).data('slides_perview_desktop');
      if (slide_perview_data && slide_perview_data > 0) {
        slides_perview_desktop = slide_perview_data;
        console.log("Contains data slides_perview_desktop: " + slides_perview_desktop);
      }
    }

    // Determine if we should center slides
    var totalSlides = $slides.find('.swiper-slide').length;
    var centerSlides = (totalSlides < slides_perview_desktop);

    new Swiper($slides[0], {
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: centerSlides,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1080: {
          slidesPerView: slides_perview_desktop,
          spaceBetween: 20,
        }
      },
      // Navigation arrows
      navigation: {
        nextEl: $next[0],
        prevEl: $prev[0],
      },
    });

  });
});

